/* eslint-disable no-console */

import { register } from 'register-service-worker'

console.log('process.env.BASE_URL = ' + process.env.BASE_URL)
console.log('process.env.NODE_ENV = ' + process.env.NODE_ENV)
var fbworkerjs 

if (process.env.NODE_ENV === 'production') {
  fbworkerjs = 'firebase-messaging-sw-production.js'
} else {
  fbworkerjs = 'firebase-messaging-sw-staging.js'
}

  //console.log(`'registering worker ' ${process.env.BASE_URL}${fbworkerjs}`)
  //register(`${process.env.BASE_URL}${fbworkerjs}`, {

  /*
    console.log(`' no ifs registering worker ' ${process.env.BASE_URL}firebase-messaging-sw.js`)
    register(`${process.env.BASE_URL}firebase-messaging-sw.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updated () {
      console.log('New content is available; please refresh.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })

*/